module.exports = __webpack_public_path__ + "51210b1d6d7954e93df369b62b37ea53.jpg";


//////////////////
// WEBPACK FOOTER
// ../~/file-loader!../loaders/scale-loader?size=410!./images/head/mythosgoldencity.jpg
// module id = 494
// module chunks = 0